"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutocompleteListContainer = exports.AutoCompleteListItems = exports.getKey = void 0;
var react_1 = __importDefault(require("react"));
var react_jss_1 = require("react-jss");
var Contexts_1 = require("../Contexts");
var Ioc_1 = require("../utilities/Ioc");
var AutocompleteList_1 = require("./AutocompleteList");
var AutocompleteListItem_1 = require("./AutocompleteListItem");
var listItemHeight = 40;
// Peek: If there are enough items to require scrolling, we always make at least half
// of any item visible at the top or bottom. Otherwise, the user has no visual indication
// that there are items to be scrolled to, especially on mobile.
// Additional content buffer: This is a "lesser of two evils" work around for the lack of
// any reliable way to know the height of the virtual keyboard. We allow the user to scroll
// far enough to ensure that the last item can be seen. The drawback, of course, is that
// when a user has plenty of space (the view is not covered by the keyboard), you can
// scroll to the bottom and see a lot of whitespace.
// I think there are some possible alternatives, including the higher level control of page scrolling,
// generally caused by iOS Safari's SPA unfriendly fuckery, but all of the ones I can think of are
// either utterly insane or simply worse. We'll figure it out someday!
var getHeightForItemCount = function (count, maxVisibleItemCount) {
    if (maxVisibleItemCount === void 0) { maxVisibleItemCount = Infinity; }
    return listItemHeight * Math.min(count, maxVisibleItemCount);
};
var getLayoutHeights = function (resultCount, maxVisibleItemCount, basePadding, breakpoint) {
    var baseItemsHeight = getHeightForItemCount(resultCount, maxVisibleItemCount);
    var isDesktop = breakpoint === "large";
    var shouldPeek = resultCount > maxVisibleItemCount + 1;
    // Here, we ensure that if there is overflow, you will always see half of an item, above or below.
    // Half of the base padding is removed so that the peek is exactly centered.
    var peekHeight = shouldPeek ? listItemHeight * 2 : 0;
    // Now, we calculate the height of the scrollable content, with the additional buffer
    // to ensure that all items can be scrolled to be visible given occlusion by the virtual
    // keyboard.
    var itemsHeight = getHeightForItemCount(resultCount);
    return {
        // The height of the scroll view
        viewHeight: isDesktop ? itemsHeight : baseItemsHeight + peekHeight + basePadding,
        // The scrollable content height within the scroll view
        contentHeight: itemsHeight,
    };
};
function getKey(item) {
    switch (item.item.type) {
        case "tag":
            return "".concat(item.item.tag.name, "__tag");
        case "performer":
            return "".concat(item.item.performer.nickname, "__performer");
        // There should only ever be 1 video item
        case "video":
            return "video";
        default:
            return "";
    }
}
exports.getKey = getKey;
var useAutocompleteListItemsStyles = (0, react_jss_1.createUseStyles)({
    labelWrapper: {
        display: "flex",
        paddingInlineStart: "8px",
        marginTop: "4px",
        color: "#9e9e9e",
        marginBottom: "4px",
    },
    lineBreak: {
        marginLeft: "8px",
        marginRight: "8px",
        color: "#e0e0e0",
        borderColor: "#e0e0e0",
        backgroundColor: " #e0e0e0",
        borderBottom: "unset !important",
        height: "2px",
    },
});
function AutoCompleteListItems(_a) {
    var autocompleteResults = _a.autocompleteResults, keyword = _a.keyword, translate = _a.translate, blurThumbnails = _a.blurThumbnails;
    var classes = useAutocompleteListItemsStyles();
    var results = [];
    function getHeaderType(type) {
        switch (type) {
            case "tag":
                return translate("search.autocomplete.tag");
            case "performer":
                return translate("search.autocomplete.performer");
            case "video":
                return translate("page_titles.videostore");
            default:
                return "";
        }
    }
    var previousHeaderType = "";
    autocompleteResults.forEach(function (result) {
        // This adds the headers where needed
        if (previousHeaderType !== result.item.type) {
            var label = (react_1.default.createElement("div", { className: classes.labelWrapper, key: "".concat(result.item.type, "_label") },
                react_1.default.createElement("div", null, getHeaderType(result.item.type))));
            if (!previousHeaderType) {
                results.push(label);
            }
            else {
                results.push(react_1.default.createElement("div", { key: "line_break_".concat(result.item.type) },
                    react_1.default.createElement("hr", { className: classes.lineBreak }),
                    label));
            }
            previousHeaderType = result.item.type;
        }
        results.push(react_1.default.createElement(AutocompleteListItem_1.AutocompleteListItem, __assign({ key: getKey(result) }, result, { keyword: keyword, listItemHeight: listItemHeight, blurThumbnails: blurThumbnails })));
    });
    return react_1.default.createElement.apply(react_1.default, __spreadArray([react_1.default.Fragment, null], __read(results), false));
}
exports.AutoCompleteListItems = AutoCompleteListItems;
var AutocompleteListContainer = function (props) {
    var _a = __read((0, Ioc_1.useContexts)(Contexts_1.IThemeContext, Contexts_1.ITranslationServiceContext, Contexts_1.ILayoutContext, Contexts_1.IUserContext), 4), theme = _a[0], translate = _a[1].translate, layout = _a[2], user = _a[3];
    var items = props.items, maxVisibleItems = props.maxVisibleItems, keyword = props.keyword, shouldUseHeaderStyles = props.shouldUseHeaderStyles;
    var breakpoint = layout.breakpoint;
    var blurThumbnails = (user === null || user === void 0 ? void 0 : user.requiresAgeConfirmation) && (!user.isAuthenticated || user.isFreemium);
    var labelCount = new Set(items.map(function (_a) {
        var item = _a.item;
        return item.type;
    })).size;
    var itemCount = items.length + labelCount;
    var hasResults = itemCount > 0;
    var padding = hasResults ? theme.spacing.base / 2 : 0;
    var listProps = __assign(__assign({ children: undefined }, getLayoutHeights(itemCount, maxVisibleItems !== null && maxVisibleItems !== void 0 ? maxVisibleItems : Number.POSITIVE_INFINITY, padding, breakpoint)), { hasResults: hasResults, maxVisibleItems: maxVisibleItems, width: shouldUseHeaderStyles ? 320 : undefined, theme: theme });
    return (react_1.default.createElement(AutocompleteList_1.AutocompleteList, __assign({}, listProps),
        react_1.default.createElement(AutoCompleteListItems, { autocompleteResults: items, keyword: keyword, translate: translate, blurThumbnails: blurThumbnails })));
};
exports.AutocompleteListContainer = AutocompleteListContainer;
exports.AutocompleteListContainer.displayName = "AutocompleteListContainer";
//# sourceMappingURL=AutocompleteListContainer.js.map